<template>
  <OmtGrid>
    <OmtRow>
      <OmtTypography as="h1-bold" mb="24px"> Protocolo {{ protocol }} </OmtTypography>
    </OmtRow>

    <OmtRow :mobileEnd="1" :desktopEnd="5" mb="16px">
      <TextTile title="Assunto" :description="assunto" />
    </OmtRow>

    <OmtRow :mobileEnd="2" :desktopStart="6" mb="16px">
      <TextTile title="Data da solicitação" :description="dataSolicitacao" />
    </OmtRow>

    <OmtRow :mobileStart="1" mb="16px">
      <TextTile title="Beneficiário" :description="beneficiario" />
    </OmtRow>

    <OmtRow :mobileEnd="1" :desktopEnd="5" mb="16px">
      <TextTile title="Código beneficiário" :description="codigoBeneficiario" />
    </OmtRow>

    <OmtRow :mobileEnd="5" :desktopStart="6" mb="16px">
      <CFlex direction="column">
        <OmtTypography as="p2" color="var(--colors-light-primary-gray2)"> Status </OmtTypography>
        <StatusTile :label="statusLabel" :color="statusColor" />
      </CFlex>
    </OmtRow>

    <OmtRow v-if="hasPendency" :desktopEnd="12" backgroundColor="#F6F6F9" borderRadius="8px" w="100%">
      <CFlex borderRadius="8px" flexDirection="Column">
        <CFlex pl="10px" pt="16px" pb="14px" align-items="center">
          <img :src="IconOmint" />
          <OmtTypography as="p1-bold"> Para continuidade da análise, solicitamos: </OmtTypography>
        </CFlex>

        <CFlex pl="35px" pb="16px">
          <ol>
            <li v-for="(it, idx) in pendencyReasons" :key="`req-${idx}`">{{ it }}</li>
          </ol>
        </CFlex>
      </CFlex>
    </OmtRow>

    <OmtRow v-if="hasPendency" justify-content="center">
      <OmtButton height="40px" fontSize="14px" mt="20px" @click="modalPendencies = true">
        Responder pendências
      </OmtButton>
    </OmtRow>

    <PendingResponseModal :reasons="pendencyReasons" :isOpen="modalPendencies" @close="closeModal" @submit="submit" />
    <SendPendency :isOpen="openModalSuccess" :protocol="protocol" @close="closeModalSendPendency" />

    <Footer />
  </OmtGrid>
</template>

<script>
import TextTile from "@/components/Molecules/TextTile";
import StatusTile from "@/components/Organisms/Sac/StatusTile.vue";
import Footer from "@/components/Molecules/Footer";
import PendingResponseModal from "@/components/Organisms/Sac/PendingResponseModal.vue";
import SendPendency from "@/components/Organisms/Sac/SendPendency.vue";
import { mapActions } from "vuex";

export default {
  name: "DetailProgramasSaude",
  components: {
    TextTile,
    StatusTile,
    Footer,
    PendingResponseModal,
    SendPendency
  },
  data() {
    return {
      detail: { Data: {} },
      modalPendencies: false,
      openModalSuccess: false,
      sending: false
    };
  },
  computed: {
    protocol() {
      return this.$route.params.protocol || "";
    },

    baseData() {
      return (this.detail && this.detail.Data) || {};
    },

    assunto() {
      return this.baseData.TipoSolicitacao || "";
    },

    dataSolicitacao() {
      return this.baseData.DtSolicitacao || "";
    },

    beneficiario() {
      return this.baseData.DsUtilizacao || "";
    },

    codigoBeneficiario() {
      return this.baseData.CdUtilizacao || "";
    },

    statusLabel() {
      return this.baseData.DsSituacao || "";
    },

    statusColor() {
      const code = this.baseData.CdSituacao || "";
      switch (code) {
        case "F":
          return "var(--colors-light-support-success)";
        case "P":
          return "var(--colors-light-support-warning)";
        case "T":
          return "var(--colors-light-primary-gray2)";
        default:
          return "var(--colors-light-primary-dark-blue)";
      }
    },

    hasPendency() {
      const p = this.baseData.Pendencia || this.baseData.Pendencias;
      if (!p) return false;

      if (this.baseData.Pendencia) {
        const pend = this.baseData.Pendencia;
        return (Array.isArray(pend.Motivos) && pend.Motivos.length > 0) || !!pend.Observacao;
      }

      if (Array.isArray(this.baseData.Pendencias)) {
        return this.baseData.Pendencias.length > 0;
      }

      return false;
    },

    pendencyReasons() {
      if (this.baseData.Pendencia && Array.isArray(this.baseData.Pendencia.Motivos)) {
        return this.baseData.Pendencia.Motivos;
      }
      if (Array.isArray(this.baseData.Pendencias)) {
        return this.baseData.Pendencias.map(p => p.Ocorrencia || p.Observacao || p);
      }
      if (this.baseData.Pendencia && this.baseData.Pendencia.Observacao) {
        return [this.baseData.Pendencia.Observacao];
      }
      return [];
    },

    IconOmint() {
      return process.env.VUE_APP_BASE_URL + "images/Group3305.png";
    }
  },
  methods: {
    ...mapActions("programasSaude", ["fetchDetalheProtocolo", "enviarRetornoPendencia"]),

    async getDetail() {
      const response = await this.fetchDetalheProtocolo({ protocolo: this.protocol });
      if (!response) {
        this.$router.replace("/programas-saude");
        return;
      }
      this.detail = response || { Data: {} };
      if (!this.detail.Data) this.detail.Data = {};
    },

    closeModal() {
      this.modalPendencies = false;
    },

    closeModalSendPendency() {
      this.openModalSuccess = false;
    },

    async submit({ pictures, obs }) {
      if (!this.hasPendency || this.sending) return;

      const arquivos = (pictures || []).map(p => p.file || p).slice(0, 20);

      if (!obs?.trim() && arquivos.length === 0) {
        this.$toast({
          description: "Inclua uma observação ou pelo menos um anexo para responder à pendência.",
          status: "warning",
          duration: 7000,
          position: "top"
        });
        return;
      }

      this.sending = true;
      try {
        this.$root.$emit("show-loading");
        const resp = await this.enviarRetornoPendencia({
          protocolo: this.protocol,
          observacao: obs?.slice(0, 350) || "",
          arquivos
        });

        if (resp && (resp.Data || resp === true)) {
          this.modalPendencies = false;
          this.openModalSuccess = true;

          await this.getDetail();
        } else {
          await this.$toast({
            description: "Não foi possível registrar o atendimento. Serviço temporariamente indisponível.",
            status: "error",
            duration: 10000,
            position: "top"
          });
        }
      } catch (err) {
        console.error(err);
        await this.$toast({
          description: "Não foi possível registrar o atendimento. Serviço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      } finally {
        this.$root.$emit("hide-loading");
        this.sending = false;
      }
    }
  },

  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.getDetail();
    } catch (error) {
      console.error(error);
    } finally {
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
img {
  margin-right: 16px;
}
.pontilhado {
  overflow: auto;
  margin-left: 10px;
  border-left: 1px dashed #8c8c8c;
  margin-bottom: 10px;
}
.resp {
  margin-left: 16px;
}
</style>
